import {NavigateToScreenRequest} from '@ui-tool/core';
import {ScreenCodes} from '@mobile-data-access-enums';

export class PaxmanIntroductionNavigationRequest extends NavigateToScreenRequest<void> {

    //#region Constructor

    public constructor() {
        super(ScreenCodes.PAXMAN_INTRODUCTION);
    }

    //#endregion
}
